import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "../FaxDirectoryForm.module.scss";

interface IDirectoryFormRowProps {
    labelKey?: string;
    exampleLabelKey?: string;
    className?: string;
    children: JSX.Element | JSX.Element[];
}

export function DirectoryFormRow(props: IDirectoryFormRowProps): JSX.Element {
    const { getText } = useTranslation();
    return (
        <div className={`${styles.directoryRow} ${props.className ?? ""}`}>
            {props.labelKey && <label className="bold">{getText(props.labelKey)}</label>}
            {props.exampleLabelKey && (<span className={styles.directoryRowExample}>{getText(props.exampleLabelKey)}</span>)}
            {props.children}
        </div>
    );
}
